import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Award, Users, TrendingUp } from 'lucide-react';

const strengths = [
  {
    icon: ShieldCheck,
    title: 'Credibility',
    description: 'Our programs are rooted in extensive research and backed by reputable partnerships.',
  },
  {
    icon: Award,
    title: 'Excellence',
    description: 'We deliver high-quality training and advisory services tailored to diverse needs.',
  },
  {
    icon: Users,
    title: 'Collaboration',
    description: 'We bring together experts, stakeholders, and institutions for impactful outcomes.',
  },
  {
    icon: TrendingUp,
    title: 'Innovation',
    description: 'Our initiatives incorporate cutting-edge approaches to address climate challenges.',
  },
];

export default function OurStrengths() {
  return (
    <section className="relative py-20 bg-gradient-to-br from-teal-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-5xl font-extrabold text-gray-900">Our Strengths</h2>
          <p className="mt-6 text-lg text-gray-700 max-w-3xl mx-auto">
            At CFSC, we pride ourselves on our unique strengths that empower us to achieve our mission 
            and deliver sustainable climate finance solutions.
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {strengths.map((strength, index) => {
            const Icon = strength.icon;
            return (
              <motion.div
                key={strength.title}
                className="relative bg-white rounded-2xl shadow-lg p-8 transform transition-all hover:shadow-2xl hover:-translate-y-2"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <div className="flex items-center justify-center h-16 w-16 bg-gradient-to-r from-green-600 to-teal-500 text-white rounded-full mx-auto">
                  <Icon className="h-8 w-8" />
                </div>
                <h3 className="mt-6 text-xl font-semibold text-gray-900 text-center">
                  {strength.title}
                </h3>
                <p className="mt-4 text-gray-600 text-center">{strength.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}